import React from "react";
import { Link } from "react-router-dom";
import "./Footer.scss";
import { DiscordLogoIcon } from "@radix-ui/react-icons";

const Footer = () => {
  return (
    <footer className="footer footer-center px-16 py-20 flex-col justify-start items-center gap-20 inline-flex">
      <div className="flex flex-col lg:flex-row self-stretch justify-start items-start gap-10 lg:gap-[200px]">
        <div className="justify-start items-start gap-6 text-left">
          <div className="self-stretch h-fit justify-start items-start gap-6">
            <div className="w-52 justify-start gap-[11px]">
              <img
                src="/new-logo.svg"
                alt="GameAway"
                className="min-w-fit min-h-fit resize-none"
              />
            </div>
            <div className="self-stretch py-4 text-base font-normal leading-normal">
              Making high-end gaming accessible to everyone.
            </div>
          </div>
        </div>
        <div className="grow shrink basis-0 h-fit justify-start items-start gap-10 flex flex-col lg:flex-row">
          <div className="grow shrink basis-0 flex-col justify-start items-start gap-4 inline-flex text-left">
            <div className="self-stretch text-neutral-50 text-base font-semibold leading-normal">
              Who we are
            </div>
            <div className="self-stretch">
              <div className="self-stretch py-2 link link-hover grow shrink basis-0 text-neutral-50 text-sm font-normal leading-[21px]">
                <Link to="/about-us">About Us</Link>
              </div>
              <div className="self-stretch py-2 link link-hover grow shrink basis-0 text-neutral-50 text-sm font-normal leading-[21px]">
                <Link to="/contact-us">Contact</Link>
              </div>
              <div className="self-stretch py-2 link link-hover grow shrink basis-0 text-neutral-50 text-sm font-normal leading-[21px]">
                <a href="https://gameaway.substack.com/" target="_blank">Blog</a>
              </div>
            </div>
          </div>
          <div className="grow shrink basis-0 flex-col justify-start items-start gap-4 inline-flex text-left">
            <div className="self-stretch text-neutral-50 text-base font-semibold leading-normal">
              Policies
            </div>
            <div className="self-stretch h-fit">
              <div className="self-stretch py-2 link link-hover grow shrink basis-0 text-neutral-50 text-sm font-normal leading-[21px]">
                <Link to="/terms-and-conditions">Terms & Conditions</Link>
              </div>
              <div className="self-stretch py-2 link link-hover grow shrink basis-0 text-neutral-50 text-sm font-normal leading-[21px]">
                <Link to="/cancellation-refund-policy">
                  Cancellation & Refund Policy
                </Link>
              </div>
              <div className="self-stretch py-2 link link-hover grow shrink basis-0 text-neutral-50 text-sm font-normal leading-[21px]">
                <Link to="/shipping-delivery-policy">
                  Shipping & Delivery Policy
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="self-stretch flex-col justify-start items-start gap-8 flex">
        <div className="self-stretch h-px bg-[var(--button-background)] border border-[var(--button-background)]" />
        <div className="flex w-full">
          <div className="self-stretch justify-between items-start lg:inline-flex hidden">
            <div className="text-[var(--muted-foreground)] text-sm font-normal leading-[21px] text-left">
              Copyright © 2025 – All rights reserved by Gameaway Cloud
              Technologies LLP
            </div>
          </div>
          <div className="flex items-start gap-3 lg:items-end lg:ml-auto">
            <a href="https://discord.gg/enfJGFcBrA" target="_blank">
              <DiscordLogoIcon className="w-[24px] h-[24px] text-muted-foreground" />
            </a>
            <a
              href="https://chat.whatsapp.com/DiRKnzQk0OE6woulWCaN3p"
              target="_blank"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
              >
                <path
                  fill="#94969C"
                  d="M 12.011719 2 C 6.5057187 2 2.0234844 6.478375 2.0214844 11.984375 C 2.0204844 13.744375 2.4814687 15.462563 3.3554688 16.976562 L 2 22 L 7.2324219 20.763672 C 8.6914219 21.559672 10.333859 21.977516 12.005859 21.978516 L 12.009766 21.978516 C 17.514766 21.978516 21.995047 17.499141 21.998047 11.994141 C 22.000047 9.3251406 20.962172 6.8157344 19.076172 4.9277344 C 17.190172 3.0407344 14.683719 2.001 12.011719 2 z M 12.009766 4 C 14.145766 4.001 16.153109 4.8337969 17.662109 6.3417969 C 19.171109 7.8517969 20.000047 9.8581875 19.998047 11.992188 C 19.996047 16.396187 16.413812 19.978516 12.007812 19.978516 C 10.674812 19.977516 9.3544062 19.642812 8.1914062 19.007812 L 7.5175781 18.640625 L 6.7734375 18.816406 L 4.8046875 19.28125 L 5.2851562 17.496094 L 5.5019531 16.695312 L 5.0878906 15.976562 C 4.3898906 14.768562 4.0204844 13.387375 4.0214844 11.984375 C 4.0234844 7.582375 7.6067656 4 12.009766 4 z M 8.4765625 7.375 C 8.3095625 7.375 8.0395469 7.4375 7.8105469 7.6875 C 7.5815469 7.9365 6.9355469 8.5395781 6.9355469 9.7675781 C 6.9355469 10.995578 7.8300781 12.182609 7.9550781 12.349609 C 8.0790781 12.515609 9.68175 15.115234 12.21875 16.115234 C 14.32675 16.946234 14.754891 16.782234 15.212891 16.740234 C 15.670891 16.699234 16.690438 16.137687 16.898438 15.554688 C 17.106437 14.971687 17.106922 14.470187 17.044922 14.367188 C 16.982922 14.263188 16.816406 14.201172 16.566406 14.076172 C 16.317406 13.951172 15.090328 13.348625 14.861328 13.265625 C 14.632328 13.182625 14.464828 13.140625 14.298828 13.390625 C 14.132828 13.640625 13.655766 14.201187 13.509766 14.367188 C 13.363766 14.534188 13.21875 14.556641 12.96875 14.431641 C 12.71875 14.305641 11.914938 14.041406 10.960938 13.191406 C 10.218937 12.530406 9.7182656 11.714844 9.5722656 11.464844 C 9.4272656 11.215844 9.5585938 11.079078 9.6835938 10.955078 C 9.7955938 10.843078 9.9316406 10.663578 10.056641 10.517578 C 10.180641 10.371578 10.223641 10.267562 10.306641 10.101562 C 10.389641 9.9355625 10.347156 9.7890625 10.285156 9.6640625 C 10.223156 9.5390625 9.737625 8.3065 9.515625 7.8125 C 9.328625 7.3975 9.131125 7.3878594 8.953125 7.3808594 C 8.808125 7.3748594 8.6425625 7.375 8.4765625 7.375 z"
                ></path>
              </svg>
            </a>
            <a href="https://www.instagram.com/gameaway.in" target="_blank">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M16 3.24219H8C5.23858 3.24219 3 5.48077 3 8.24219V16.2422C3 19.0036 5.23858 21.2422 8 21.2422H16C18.7614 21.2422 21 19.0036 21 16.2422V8.24219C21 5.48077 18.7614 3.24219 16 3.24219ZM19.25 16.2422C19.2445 18.0348 17.7926 19.4867 16 19.4922H8C6.20735 19.4867 4.75549 18.0348 4.75 16.2422V8.24219C4.75549 6.44954 6.20735 4.99768 8 4.99219H16C17.7926 4.99768 19.2445 6.44954 19.25 8.24219V16.2422ZM16.75 8.49219C17.3023 8.49219 17.75 8.04447 17.75 7.49219C17.75 6.93991 17.3023 6.49219 16.75 6.49219C16.1977 6.49219 15.75 6.93991 15.75 7.49219C15.75 8.04447 16.1977 8.49219 16.75 8.49219ZM12 7.74219C9.51472 7.74219 7.5 9.75691 7.5 12.2422C7.5 14.7275 9.51472 16.7422 12 16.7422C14.4853 16.7422 16.5 14.7275 16.5 12.2422C16.5027 11.0479 16.0294 9.90176 15.1849 9.05727C14.3404 8.21278 13.1943 7.73953 12 7.74219ZM9.25 12.2422C9.25 13.761 10.4812 14.9922 12 14.9922C13.5188 14.9922 14.75 13.761 14.75 12.2422C14.75 10.7234 13.5188 9.49219 12 9.49219C10.4812 9.49219 9.25 10.7234 9.25 12.2422Z"
                  fill="#94969C"
                />
              </svg>
            </a>
            <a
              href="https://www.linkedin.com/company/gameaway-cloud/about/?viewAsMember=true"
              target="_blank"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M4.5 3.24219C3.67157 3.24219 3 3.91376 3 4.74219V19.7422C3 20.5706 3.67157 21.2422 4.5 21.2422H19.5C20.3284 21.2422 21 20.5706 21 19.7422V4.74219C21 3.91376 20.3284 3.24219 19.5 3.24219H4.5ZM8.52076 7.24491C8.52639 8.20116 7.81061 8.79038 6.96123 8.78616C6.16107 8.78194 5.46357 8.14491 5.46779 7.24632C5.47201 6.40116 6.13998 5.72194 7.00764 5.74163C7.88795 5.76132 8.52639 6.40679 8.52076 7.24491ZM12.2797 10.0039H9.75971H9.7583V18.5638H12.4217V18.3641C12.4217 17.9842 12.4214 17.6042 12.4211 17.2241C12.4203 16.2103 12.4194 15.1954 12.4246 14.1819C12.426 13.9358 12.4372 13.6799 12.5005 13.445C12.7381 12.5675 13.5271 12.0008 14.4074 12.1401C14.9727 12.2286 15.3467 12.5563 15.5042 13.0893C15.6013 13.4225 15.6449 13.7811 15.6491 14.1285C15.6605 15.1761 15.6589 16.2237 15.6573 17.2714C15.6567 17.6412 15.6561 18.0112 15.6561 18.381V18.5624H18.328V18.3571C18.328 17.9051 18.3278 17.4532 18.3275 17.0013C18.327 15.8718 18.3264 14.7423 18.3294 13.6124C18.3308 13.1019 18.276 12.5985 18.1508 12.1049C17.9638 11.3708 17.5771 10.7633 16.9485 10.3246C16.5027 10.0124 16.0133 9.81129 15.4663 9.78879C15.404 9.7862 15.3412 9.78281 15.2781 9.7794C14.9984 9.76428 14.7141 9.74892 14.4467 9.80285C13.6817 9.95613 13.0096 10.3063 12.5019 10.9236C12.4429 10.9944 12.3852 11.0663 12.2991 11.1736L12.2797 11.1979V10.0039ZM5.68164 18.5666H8.33242V10.0095H5.68164V18.5666Z"
                  fill="#94969C"
                />
              </svg>
            </a>
            <a href="https://www.youtube.com/@gameaway7330" target="_blank">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M21.5931 7.20301C21.4792 6.78041 21.2566 6.39501 20.9475 6.08518C20.6383 5.77534 20.2534 5.55187 19.8311 5.43701C18.2651 5.00701 12.0001 5.00001 12.0001 5.00001C12.0001 5.00001 5.73609 4.99301 4.16909 5.40401C3.74701 5.52415 3.36291 5.75078 3.05365 6.06214C2.7444 6.3735 2.52037 6.75913 2.40309 7.18201C1.99009 8.74801 1.98609 11.996 1.98609 11.996C1.98609 11.996 1.98209 15.26 2.39209 16.81C2.62209 17.667 3.29709 18.344 4.15509 18.575C5.73709 19.005 11.9851 19.012 11.9851 19.012C11.9851 19.012 18.2501 19.019 19.8161 18.609C20.2386 18.4943 20.6238 18.2714 20.9337 17.9622C21.2436 17.653 21.4675 17.2682 21.5831 16.846C21.9971 15.281 22.0001 12.034 22.0001 12.034C22.0001 12.034 22.0201 8.76901 21.5931 7.20301ZM9.99609 15.005L10.0011 9.00501L15.2081 12.01L9.99609 15.005Z"
                  fill="#94969C"
                />
              </svg>
            </a>
          </div>
        </div>
        <div className="self-stretch justify-between items-start inline-flex lg:hidden">
          <div className="text-[var(--muted-foreground)] text-sm font-normal leading-[21px] text-left">
            Copyright © 2025 – All rights reserved by Gameaway Cloud
            Technologies LLP
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
